// @flow
import { call, put, race, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import type { Id, PollNodeExistsAction } from './types';
import { MAX_POLL_TIMEOUT, POLL_NODE_EXISTS, CREATION_FAILED } from './constants';

import { getNodeCreationStatus } from '~/core/api/nodes/nodes.api';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { noop } from 'lodash/fp';

function* poll(id: Id): Generator<noop | Effect, *, *> {
    while (true) {
        const [res] = yield call(handleApi(getNodeCreationStatus), id);
        const { nodes = [] } = res;
        const [node] = nodes;

        if (node && node.id) {
            return node.id;
        }

        if (node && node.creationRequest && node.creationRequest.status === CREATION_FAILED) {
            throw new Error(`Creation of node ${id} failed`);
        }

        yield call(delay, 1000);
    }
}

function* pollNodeExists({ payload: { id, nextAction } }: PollNodeExistsAction): Generator<noop | Effect, *, *> {
    try {
        const { nodeId } = yield race({
            nodeId: call(poll, id),
            timeout: call(delay, MAX_POLL_TIMEOUT)
        });

        if (nodeId) {
            const action = typeof nextAction === 'function' ? nextAction({ nodeId }) : nextAction;
            return yield put(action);
        }

        if (typeof nextAction === 'function') {
            return yield put(nextAction(new Error('Node creation timed out')));
        }
    } catch (e) {
        if (typeof nextAction === 'function') {
            yield put(nextAction(e));
        }
    }
}

function* watchPollNodeExists(): Generator<Effect, *, *> {
    yield takeLatest(POLL_NODE_EXISTS, handleSaga(pollNodeExists));
}

export default [watchPollNodeExists];



// WEBPACK FOOTER //
// ./src/core/state/honeycomb/sagas.js